'use strict';

var processInclude = require('base/util');

function initCheck() {
    $('.terms').on('click', function() {
        if ($(this).hasClass('checked')) {
            $(this).removeClass('checked').addClass('unchecked');
            $('.form-terms-confirm-error').css('display', 'block');

        } else {
            $(this).addClass('checked').removeClass('unchecked');
            $('.form-terms-confirm-error').css('display', 'none');
        }
    });

    $('.video_play').on('click', function() {
        if(this.paused){
          this.play();
          $('.play-btn-TplN2A').css('display','none');
        } else {
          this.pause();
          $('.play-btn-TplN2A').css('display','block');
        }
    });
    $('.polygon-1-LbHl81').on('click', function() {
        $($(this).data('video_id')).trigger('play');
        $('.play-btn-TplN2A').css('display','none');
    });

    $('.video_play2').on('click', function() {
        if(this.paused){
          this.play();
          $('.play-btn-TplN2A2').css('display','none');
        } else {
          this.pause();
          $('.play-btn-TplN2A2').css('display','block');
        }
    });
    $('.polygon-1-LbHl812').on('click', function() {
        $($(this).data('video_id')).trigger('play');
        $('.play-btn-TplN2A2').css('display','none');
    });

    $('.closeAccordion').on('click', function() {
        $(this).closest('.accordion-collapse').collapse('toggle');
    });


$(function() {
    $("#panelsStayOpen-collapseOne").on("hide.bs.collapse", function(){
        var learnmoretext = $('.pp-but').data('learnmore-text');
        $(".pp-but").html('<span>'+learnmoretext+'</span>');
    });
    $("#panelsStayOpen-collapseOne").on("show.bs.collapse", function(){
        var closetext = $('.pp-but').data('close-text');
        $(".pp-but").html('<span>'+closetext+'<i class="fa fa-angle-up fa-lg"></i></span>');

    });
});

$(function() {
$("#panelsStayOpen-collapseTwo").on("hide.bs.collapse", function(){
    var learnmoretext = $('.pp-but').data('learnmore-text');
    $(".pp-but2").html('<span>'+learnmoretext+'</span>');
});
$("#panelsStayOpen-collapseTwo").on("show.bs.collapse", function(){
    var closetext = $('.pp-but').data('close-text');
    $(".pp-but2").html('<span>'+closetext+'<i class="fa fa-angle-up fa-lg"></i></span>');

});
});
$(function() {
    $("#panelsStayOpen-collapseThree").on("hide.bs.collapse", function(){
        var learnmoretext = $('.pp-but').data('learnmore-text');
        $(".pp-but3").html('<span>'+learnmoretext+'</span>');
    });
    $("#panelsStayOpen-collapseThree").on("show.bs.collapse", function(){
        var closetext = $('.pp-but').data('close-text');
        $(".pp-but3").html('<span>'+closetext+'<i class="fa fa-angle-up fa-lg"></i></span>');

    });
});
$(function() {
    $("#panelsStayOpen-collapseFour").on("hide.bs.collapse", function(){
        var learnmoretext = $('.pp-but').data('learnmore-text');
        $(".pp-but4").html('<span>'+learnmoretext+'</span>');
    });
    $("#panelsStayOpen-collapseFour").on("show.bs.collapse", function(){
        var closetext = $('.pp-but').data('close-text');
        $(".pp-but4").html('<span>'+closetext+'<i class="fa fa-angle-up fa-lg"></i></span>');

    });
});
    $(document).ready(function() {
        var allSlides = $('.carousel-item').length;
        var activeSlideIndex = $('.carousel-item.active').index() + 1;
        $('.conteoCarrusel').html('' + '0' + activeSlideIndex + ' / ' + '0' + allSlides + '');
        $('#carouselExampleControls').on('slid.bs.carousel', function () {
            activeSlideIndex = $('.carousel-item.active').index() + 1;
            $('.conteoCarrusel').html('' + '0' + activeSlideIndex + ' / ' + '0' + allSlides + '');
        });

        var getScrollbarWidth = function() {
            var div = document.createElement("div");
            div.style.overflow = "scroll";
            div.style.visibility = "hidden";
            div.style.position = 'absolute';
            div.style.width = '100px';
            div.style.height = '100px';
            document.body.appendChild(div);
            var scrollbarWidth = div.offsetWidth - div.clientWidth;
            div.remove();
            return scrollbarWidth;
        };

        var style = document.createElement('style');
        style.innerHTML = '.noScroll{padding-right: ' + getScrollbarWidth() + 'px}';
        document.head.appendChild(style);

        $(".nav-item-multilanguage").click(function (e) {
            if ($('#allinonemodal.show').length) {
                $('#allinonemodal').modal('hide');
                $(".menu-global").attr('allinonemodal', 'show');
            }
            $(".menu-global").closest('.navbar-collapse').addClass('show');
            $(".menu-global").fadeIn(500);
            $('body').addClass('noScroll');
        });
        // Close menu languages.
        $(".menu-global").click(function (e) {
            $(".menu-global").fadeOut(500);
            $(".menu-global").closest('.navbar-collapse').removeClass('show');
            $('body').removeClass('noScroll');
            if ($(".menu-global").attr('allinonemodal') === 'show') {
                $('#allinonemodal').modal('show');
                $(".menu-global").attr('allinonemodal', 'none');
            }
        });

        $(".menu-global .button-closed").click(function (e) {
            $(".menu-global").fadeOut(500);
            $(".menu-global").closest('.navbar-collapse').removeClass('show');
            $('body').removeClass('noScroll');
            if ($(".menu-global").attr('allinonemodal') === 'show') {
                $('#allinonemodal').modal('show');
                $(".menu-global").attr('allinonemodal', 'none');
            }
        });

        $(document).on("click", '.foot-mobile-title', function() {
            $(this).toggleClass('expand');
        });

        /**auto hide link/menu item if href none**/
        $('.nav-item .nav-link.link[href="#"]').each(function () {
            $(this).parent().addClass('d-none');
        });

        /**auto hide link if href none**/
        /**change svg color in img tag**/
        $('img.svg[src$=".svg"], .footer-social-icon img[src$=".svg"]').each(function (index, img) {
            var imgID = img.id;
            var imgClass = img.className;
            var imgURL = img.src;

            fetch(imgURL).then(function (response) {
                return response.text();
            }).then(function (text) {

                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(text, "text/xml");

                // Get the SVG tag, ignore the rest
                var svg = xmlDoc.getElementsByTagName('svg')[0];

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    svg.setAttribute('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    svg.setAttribute('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                svg.removeAttribute('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
                    svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'))
                }

                // Replace image with new SVG
                img.parentNode.replaceChild(svg, img);

            });
        });
    /**change svg color in img tag**/

    });
}

module.exports = {
    initCheck: initCheck()
};

processInclude(module.exports);
